import PROXY_CONFIG from "Config/ProxyConfig";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import formatUrl from "utils/FormatUrl";
import Uploaded from "../../../../components/v3/Estimation/icons/Uploaded";
import {
  actions as creditDemandActions,
  selectors as CreditDemandeSelectors,
} from "../../../../redux/slices/v2/DemandeUnCredit";
import style from "./fifthStep.module.css";
import api_call_v2 from "utils/API_CALL/api_call_v2";

function FifthStep(props: any) {
  //
  // const { t, lang } = useTranslation("common");
  const activeStep = useSelector(CreditDemandeSelectors.activeStepSelector);
  const data = useSelector(CreditDemandeSelectors.selectDemandUnCredit);

  const dispatch = useDispatch();

  const setNextStep = (step) => {
    dispatch(creditDemandActions.setActivesTep(step));
  };
  const setPreviousStep = (step) => {
    dispatch(creditDemandActions.setActivesTep(step));
  };

  const [recuperationUploaded, setRecuperationUploaded] =
    useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    api_call_v2(
      undefined,
      "post",
      "addDemandeCredit",
      data
    ).then(() => {
      setTimeout(() => {
        setRecuperationUploaded(true);
      }, 3000);
      setTimeout(() => {
        setLoading(false);
      }, 3500);
    });
    
  }, []);

  const message =
    "Bonjour, j'aimerai me faire accompagner dans ma demande de crédit immobilier";
  const phoneNumber = "+212669793808";
  const linkToWhatsapp = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  return (
    <div className={style.leftSideContent}>
      <div className={style.whatsapp}>
        <a href={linkToWhatsapp} target="_blank">
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2749 16.742C20.9212 16.5565 19.2102 15.6533 18.8976 15.5162C18.5851 15.3791 18.3383 15.3226 18.0915 15.6613C17.8447 16 17.1291 16.7581 16.9152 16.9839C16.7014 17.2097 16.4957 17.2258 16.142 17.0404C15.7883 16.8549 14.6614 16.4436 13.3535 15.2017C12.3335 14.242 11.6672 13.0726 11.4698 12.7178C11.2723 12.3629 11.4698 12.1775 11.6507 12.0081C11.8317 11.8388 12.0209 11.6129 12.2101 11.4113C12.3993 11.2097 12.4569 11.0726 12.5885 10.8388C12.7201 10.6049 12.6625 10.4033 12.5885 10.2259C12.5144 10.0484 11.8646 8.31456 11.5931 7.59682C11.3217 6.87908 11.0256 6.99198 10.8117 6.98392C10.5978 6.97586 10.3675 6.93553 10.129 6.93553C9.76702 6.93553 9.41331 7.07263 9.16654 7.33876C8.82928 7.6694 7.87509 8.48392 7.80928 10.1936C7.74347 11.9033 8.94444 13.621 9.11718 13.8629C9.28992 14.1049 11.4286 17.8145 14.9822 19.3387C18.5357 20.8629 18.5604 20.4033 19.2102 20.3629C19.8601 20.3226 21.3407 19.5968 21.6697 18.7984C21.9988 18 22.0235 17.2984 21.9412 17.1533C21.8589 17.0081 21.6204 16.9113 21.2749 16.7178V16.742ZM14.7518 25.0081C12.4898 25.0081 10.2688 24.3549 8.38508 23.1291L3.93493 24.5242L5.38267 20.3065C3.94316 18.371 3.16993 16.0404 3.17816 13.6452C3.17816 7.37908 8.36863 2.29038 14.7601 2.29038C21.1515 2.29038 26.342 7.37908 26.342 13.6452C26.342 19.9113 21.1433 25 14.7601 25L14.7518 25.0081ZM14.7518 0.0161896C7.06896 0.0161896 0.84203 6.12102 0.84203 13.6533C0.84203 16.1371 1.52477 18.5726 2.8409 20.6936L0.332031 28.0081L8.03137 25.5887C10.0878 26.7016 12.4075 27.2903 14.7518 27.2903C22.4347 27.2903 28.6617 21.1855 28.6617 13.6533C28.6617 6.12102 22.4347 0.0161896 14.7518 0.0161896Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
      {isLoading ? (
        // <Loading />
        <div className={style.element}>
          {recuperationUploaded ? (
            <Uploaded />
          ) : (
            <div className={style.loader_container}>
              <div className={style.loader}></div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div className={style.finalStep}>
            <div className={`${style.questMob}`}>
              <p className={style.title}>{props?.titre}</p>
              <p className={style.subTitle}>{props?.subTitle}</p>
            </div>
            <p className={style.desc}>
              {props?.Title2}{" "}
              <a href={formatUrl(props.Button_link)}>{props.Button_text}</a>{" "}
              {props.title3}{" "}
              <a href={formatUrl(props.Button_link2)}>{props.Button_text2}</a>.
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default FifthStep;
